import type { RouteRecordRaw } from 'vue-router'
import { requiresOrgFeature } from '@/apps/settings/routes'
import { PublicFlags } from '@/types/permissions'

// Both screens behind the organization's flag, asked by the organization gate guard.
const gate = requiresOrgFeature(PublicFlags.CLIPS_ENABLED)

export const clipsRoutes: RouteRecordRaw[] = [
  {
    path: 'clips',
    name: 'clips',
    component: () => import('./views/ClipsListView.vue'),
    meta: {
      title: 'Clips',
      gate,
    },
  },
  {
    path: 'clips/:projectId/editor',
    name: 'clips:editor',
    component: () => import('./views/ClipEditorView.vue'),
    meta: {
      title: 'Clip Editor',
      gate,
    },
  },
]

export default clipsRoutes
